import React from 'react';
import { memoize } from 'react-data-table-component';
import { Edit2, Trash } from 'react-feather';
import { Button } from 'react-bootstrap';

const columnsAdmin = memoize(clickHandler => [
  {
    name: 'NOMBRE',
    selector: 'name',
    sortable: true,
    grow: 1
  },
  {
    name: 'COMUNA',
    selector: 'commune',
    grow: 1
  },
  {
    name: 'CANTIDAD DE ESTUDIANTES',
    selector: 'students',
    grow: 1
  },
  {
    name: 'REGION',
    selector: 'region',
    grow: 1
  },
  {
    name: 'RBD',
    selector: 'rbd',
    right: true
  },
  {
    cell: infoItem => (
      <div>
        <Button
          variant="outline-primary"
          size="sm"
          className="mr-2"
          onClick={() => clickHandler(infoItem, 'edit')}
        >
          <Edit2 className="small-svg" />
        </Button>
        <Button
          variant="outline-danger"
          size="sm"
          onClick={() => clickHandler(infoItem, 'delete')}
        >
          <Trash className="small-svg" />
        </Button>
      </div>
    ),
    ignoreRowClick: true,
    allowOverflow: true,
    button: true,
    grow: 1
  }
]);

const columns = memoize(() => [
  {
    name: 'NOMBRE',
    selector: 'name',
    sortable: true
  },
  {
    name: 'COMUNA',
    selector: 'commune',
    right: true
  },
  {
    name: 'CANTIDAD DE ESTUDIANTES',
    selector: 'students',
    right: true
  },
  {
    name: 'REGION',
    selector: 'region',
    right: true
  },
  {
    name: 'RBD',
    selector: 'rbd',
    right: true
  }
]);

export { columns, columnsAdmin };
